export default function Modal ({ title, content }) {

	const styles = {
    backdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      // background: 'rgba(0,0,0,0.7)',
      background: 'rgba(0,0,0)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 9999,
    },
    modal: {
      background: '#fff',
      padding: '2rem',
      borderRadius: '10px',
      textAlign: 'center',
      maxWidth: '80%',
    },
  };

	return (
		<>
			<div style={styles.backdrop}>
				<div style={styles.modal}>
					<h2>{title}</h2>
					<p>{content}</p>
				</div>
			</div>
		</>
	)
}